
var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.ProductRequest = new Class({
    Implements: [Class.Thenable, Options, Events],
    options: {
        entry_id: ''
    },
    bound_methods: {},
    initialize: function (op) {
        this.setOptions(op);
        this.bound_methods.on_product_fetched = this.on_product_fetched.bind(this);
        var pm = OCS.WxBriefing.Functions.get_product_manager();
        pm.addEvent(pm.options.product_fetched_event, this.bound_methods.on_product_fetched);
    },
    start: function() {
        var pm = OCS.WxBriefing.Functions.get_product_manager();
        var product = pm.fetch_product(this.options.entry_id);
        if(product) {
            this.on_product_fetched(product);
        }
    },
    on_product_fetched: function(product) {
        if(parseInt(product.options.entry_id) === parseInt(this.options.entry_id)) {
            this.resolve(product);
            var pm = OCS.WxBriefing.Functions.get_product_manager();
            pm.removeEvent(pm.options.product_fetched_event, this.bound_methods.on_product_fetched);
        }
        this.fireEvent('complete', product);
    }
    
});

